/**
 * Project Stats React Query hooks
 * One hook per stats tab, each fetching data lazily
 */

import { useQuery } from '@tanstack/react-query';
import * as statsApi from '@/services/statsApi';

const STALE_TIME = 5 * 60 * 1000; // 5 minutes

export const projectStatsKeys = {
  all: ['projectStats'] as const,
  extension: () => [...projectStatsKeys.all, 'extension'] as const,
  crawler: () => [...projectStatsKeys.all, 'crawler'] as const,
  crossProject: () => [...projectStatsKeys.all, 'crossProject'] as const,
  workers: () => [...projectStatsKeys.all, 'workers'] as const,
};

export function useExtensionStats(enabled = true) {
  return useQuery({
    queryKey: projectStatsKeys.extension(),
    queryFn: statsApi.getExtensionStats,
    staleTime: STALE_TIME,
    enabled,
  });
}

export function useCrawlerStats(enabled = true) {
  return useQuery({
    queryKey: projectStatsKeys.crawler(),
    queryFn: statsApi.getCrawlerStats,
    staleTime: STALE_TIME,
    enabled,
  });
}

export function useCrossProjectStats(enabled = true) {
  return useQuery({
    queryKey: projectStatsKeys.crossProject(),
    queryFn: statsApi.getCrossProjectStats,
    staleTime: STALE_TIME,
    enabled,
  });
}

export function useWorkerStats(enabled = true) {
  return useQuery({
    queryKey: projectStatsKeys.workers(),
    queryFn: statsApi.getWorkerStats,
    staleTime: STALE_TIME,
    enabled,
  });
}
